import {
  Alert,
  expected,
  schAlertType,
  schPairedCostRouteItem,
  schPairedCostRouteItemWithQuery,
} from '@aloft/toolkit-shared';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../../redux/types.ts';
import {
  LocationType,
  formatMiles,
  getLocationTypeProximityRequirementMiles,
} from '../../../../utils/locationTypeProximityRequirementMiles.ts';
import { proximityMiles } from '../../../../utils/proximityMiles.ts';
import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';

export const outsideProximityRequirement: AlertDefinition = ({
  compSequence,
  propertyDataEntities,
  order,
}) => {
  const subject = propertyDataEntities.subject as SubjectPropertyDataState | undefined;
  const locationType = subject?.subjectData.editableData.propertyIdentification.locationType as
    | LocationType
    | undefined;
  const proximityRequirementMiles = getLocationTypeProximityRequirementMiles(locationType);
  const subjectCoords = subject?.subjectData.editableData.propertyIdentification.coordinates;

  if (!locationType || proximityRequirementMiles === undefined || !subjectCoords) return [];

  return compSequence
    .map((id, index) => {
      const comp = propertyDataEntities[id] as CompPropertyDataState | undefined;
      const coords = comp?.compData.editableData.propertyIdentification.coordinates;
      if (!coords) return undefined;

      const miles = proximityMiles(subjectCoords, coords);
      if (miles === undefined || miles <= proximityRequirementMiles) return undefined;

      const compIndex = index + 1;

      return {
        type: schAlertType.enum.outsideProximityRequirement,
        status: 'active' as const,
        severity: 'warning' as const,
        orderType: ['appraisify'],
        message: `Comp ${compIndex} is outside the suggested ${formatMiles(proximityRequirementMiles)} proximity for ${locationType} locations.`,
        propertyID: id,
        fixingInfo: {
          tips: 'Tips: Use the Recommended Comps tool to replace out-of-range comps.',
          pairedCostRouteItem: expected(
            schPairedCostRouteItemWithQuery.parse('features?addComps=true'),
          ),
          fixingMethod: ['action'] as const,
          commentAlwaysRequired: false,
        },
        triggers: getAlertTriggers({ fixRoute: schPairedCostRouteItem.enum.features, order }),
      } as Alert;
    })
    .filter((alert): alert is Alert => alert !== undefined);
};
